<<<<<<< HEAD
<template>
    <div>
        <div class="number-complaint ml lf">
          <!-- <title-h3 :titlemsg="titlemsg"></title-h3> -->
          <div class="content-wrap">
            <div class="inner-content-wrap">
              <div id="myChart1" style="width:96%;height:3rem;margin: 0 auto;"></div>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import title from '../title'
export default {
  name: 'numberComplaints',
  data(){
    return {
      titlemsg:"护理数量",
    }
  },
  mounted(){
    this.drawLine();
  },
  updated(){

  },
  methods:{
    drawLine(){
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart1'));
        // 绘制图表
        // 指定图表的配置项和数据
        // var option = ''
        // myChart.setOption(option);
        var option = {
            title : {
                text: '七天护理数量',
                x:'left',
                textStyle:{
                color:'#fff',
                fontWeight: '100',
                fontSize: 16
                }
            },
            legend:{  // 对应series的name
                orient: 'vertical',
                left: '5%',
                top:'10%',
                itemGap:13,
                itemHeight:16,
                itemwidth:31,
                data:['1月','2月','3月','4月','5月','6月','7月','8月'],
                textStyle:{
                    color:'#fff'
                }
            },
            grid: {
                left: '20%',
                right: '10%',
                bottom: '3%',
                containLabel: true
            },
            tooltip : {
                //trigger: 'axis',    //显示其他分类
                axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                    type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                }
            },
            xAxis : [
                {
                    type : 'category',
                    data : ['1月','2月','3月','4月','5月','6月','7月','8月'],
                    axisLabel: {
                        textStyle: {
                            color: '#fff'
                        }
                    },
                    axisTick: {
                    show: false
                    },
                    axisLine: {
                    show: false
                    }
                }
            ],
            yAxis : [
                {
                    type : 'value',
                    axisLine: {
                        lineStyle: {
                            type: 'solid',
                            color: '#fff',//左边线的颜色
                        }
                        },
                }
            ],
            series : [
                {
                    name:'1月',
                    stack: '广告',  //设置分类，同一类合并，多个series数据成一个柱
                    type:'bar',
                    color:"#f29e9e",
                    barWidth : 22,
                    data:[320]
                },
                {
                    name:'2月',
                    type:'bar',
                    stack: '广告',
                    data:[0, 132],
                    color:'#5ea5da'
                },
                {
                    name:'3月',
                    type:'bar',
                    stack: '广告',
                    data:[0, 0, 191,],
                    color:'#a7d17d'
                },
                {
                    name:'4月',
                    type:'bar',
                    stack: '广告',
                    data:[0, 0, 0, 154],
                    color:'#8ebbe5'
                },
                {
                    name:'5月',
                    stack: '广告',  //设置分类，同一类合并，多个series数据成一个柱
                    type:'bar',
                    color:"#c4a7ce",
                    data:[0,0,0,0,145]
                },
                {
                    name:'6月',
                    type:'bar',
                    stack: '广告',
                    data:[0,0,0,0,0,325],
                    color:'#f3a397'
                },
                {
                    name:'7月',
                    type:'bar',
                    stack: '广告',
                    data:[0,0,0,0,0,0,145],
                    color:'#848dc5'
                },
                {
                    name:'8月',
                    type:'bar',
                    stack: '广告',
                    data:[0,0,0,0,0,0,0,145],
                    color:'#8ebbe5'
                },
            ]
        };
        // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    }
  },
  components: {
    'title-h3': title
  }
}

</script>
<style scoped>
  .number-complaint{width: 65.4%;height:4.06rem;}
  .number-complaint .content-wrap{width: 100%; height: 3.53rem; margin-top: 0.03rem;  border-radius: 4px; padding-top: .1rem}
  .number-complaint .inner-content-wrap{width: 97%; margin: 0 auto; height: 3.43rem;}
  #myChart1{width: 96%; margin: 0 auto;height:3rem; padding-top:.215rem; overflow: hidden}
</style>
=======
<template>
    <div>
        <div class="number-complaint ml lf">
          <div class="content-wrap">
            <div class="inner-content-wrap">
              <div id="myChart1" style="width:96%;height:3rem;margin: 0 auto;"></div>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import * as echarts from 'echarts';
import dataJson from '../../assets/js/new_v.json'
import Axios from 'axios'
import title from '../title'
export default {
  name: 'numberComplaints',
  data(){
    return {
      titlemsg:"数据分析",
      dataJson:dataJson,
      timer:null
    }
  },
  mounted(){
    this.drawLine();
    this.setInter();
  },
  updated(){

  },
  methods:{
    setInter(){

      let that = this
      that.timer = setInterval(function(){
          // that.drawLine()
		  that.$nextTick(() => {
			  //使echarts尺寸重置
			  that.$echarts.init(document.getElementById("myChart1")).resize();
			});
      },3000)
    },
    drawLine(){
      console.log('2222')
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart1'));
        // 绘制图表
       var option;
       option = {}
       myChart.setOption(option);

       option = {
         title: {
           text: '供应商数据分析',
           textStyle:{
           color:'#fff',
           fontWeight: '100',
           fontSize: 16
           }
         },
         tooltip: {
           trigger: 'axis',
           axisPointer: {
             type: 'cross',
             label: {
               backgroundColor: '#6a7985'
             }
           }
         },
         legend: {
           data: ['入驻总数', '商品总数', '服务总数'],
           textStyle:{
               color:'#fff'
           }
         },
         toolbox: {
           feature: {
             saveAsImage: {}
           }
         },
         grid: {
           left: '3%',
           right: '4%',
           bottom: '3%',
           containLabel: true
         },
         xAxis: [
           {
             type: 'category',
             boundaryGap: false,
             data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
             axisLabel: {
                 textStyle: {
                     color: '#fff'
                 }
             },
             axisLine: {
                 lineStyle: {
                     type: 'solid',
                     color: '#fff',//左边线的颜色
                 }
              },
           }
         ],
         yAxis: [
           {
             type: 'value',
             axisLabel: {
                 textStyle: {
                     color: '#fff'
                 }
             },
             axisLine: {
                 lineStyle: {
                     type: 'solid',
                     color: '#fff',//左边线的颜色
                 }
              },
           }
         ],
         series: [
           {
             name: '商品总数',
             type: 'line',
             color:"#f29e9e",
             stack: 'Total',
             areaStyle: {},
             emphasis: {
               focus: 'series'
             },
             data: [150, 232, 201, 154, 190, 330, 410]
           },
           {
             name: '服务总数',
             type: 'line',
             stack: 'Total',
             color:'#5ea5da',
             areaStyle: {},
             emphasis: {
               focus: 'series'
             },
             data: [320, 332, 301, 334, 390, 330, 320]
           },
           {
             name: '入驻总数',
             type: 'line',
             stack: 'Total',
             label: {
               show: true,
               position: 'top'
             },
             areaStyle: {},
             emphasis: {
               focus: 'series'
             },
             data: [820, 932, 901, 934, 1290, 1330, 1320]
           }
         ]
       };

       option && myChart.setOption(option);
    }
  },
  components: {
    'title-h3': title
  }
}

</script>
<style scoped>
  .number-complaint{width: 65.4%;height:4.06rem;}
  .number-complaint .content-wrap{width: 100%; height: 3.53rem; margin-top: 0.03rem;  border-radius: 4px; padding-top: .1rem}
  .number-complaint .inner-content-wrap{width: 97%; margin: 0 auto; height: 3.43rem;}
  #myChart1{width: 96%; margin: 0 auto;height:3rem; padding-top:.215rem; overflow: hidden}
</style>
>>>>>>> 30190837a447857154197d8be8904236674f8f25



// WEBPACK FOOTER //
// src/components/supplier/numberComplaints.vue